import { Modal, Col, Row, Space, Typography, Dropdown, message } from "antd";
import AssetTypesFormDialog from "../components/AssetTypesFormDialog";
import { useState } from "react";
import { Guid } from "guid-typescript";
import AssetTypesView from "../components/AssetTypesView";
import { SearchQuery } from "../code/search-query/search-query";
import { getAssetTypesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { AssetType } from "../repository/data.default";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function AssetTypesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<AssetType>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onInputOpen(
    mode: "add" | "update" | "delete",
    values?: AssetType,
  ): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onInputClose(): void {
    setInputOpen(false);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading asset-types export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getAssetTypesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Asset Types
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("AssetTypes", "create")}

            className={`${!permissions.can("AssetTypes", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("AssetTypes", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInputOpen("add")}
          >
            Add Asset Type
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <AssetTypesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <AssetTypesFormDialog
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={onInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default AssetTypesPage;
